import { render, staticRenderFns } from "./Quick-note-component.vue?vue&type=template&id=13efdc8b&"
import script from "./Quick-note-component.vue?vue&type=script&lang=js&"
export * from "./Quick-note-component.vue?vue&type=script&lang=js&"
import style0 from "./Quick-note-component.vue?vue&type=style&index=0&id=13efdc8b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports